import { SingleScrollView, SizedBox } from "../../../common/components/CommonBaseComponents";
import DeviceDetailCard from "../components/DeviceDetailCard";
import { useEffect, useState } from "react";
import StoreService from "../../../service/StoreService";

const IN_USE_STATES = new Set([
    "RUNNING",
    "DETECTING",
    "SOAKING",
    "WASHING",
    "RINSING",
    "SPINNING",
    "DRYING",
    "COOLING",
    "STEAM",
    "REFRESHING",
]);

const STANDBY_STATES = new Set(["INITIAL", "STANDBY", "PAUSE", "RESERVED", "END", "COMPLETE", "FINISHED"]);

const OFFLINE_STATES = new Set(["POWEROFF", "POWER_OFF", "OFFLINE", "DISCONNECTED"]);

const toCardStatus = (state, error, online) => {
    if (error && error !== "ERROR_NO") return "error";
    if (online === false) return "offline";
    if (IN_USE_STATES.has(state)) return "inUse";
    if (STANDBY_STATES.has(state)) return "standby";
    if (OFFLINE_STATES.has(state)) return "offline";
    return "offline";
};

// deviceType 211 + productType combo → combo / deviceType 212 → dryer / 그 외 → washer
const resolveDeviceType = (deviceType, productType) => {
    if (deviceType === "211" && (productType ?? "").toLowerCase().includes("combo")) return "combo";
    if (deviceType === "212") return "dryer";
    return "washer";
};

const parseDeviceList = (result) =>
    (Array.isArray(result) ? result : []).map((device) => {
        const snapshot = device.snapshot ?? {};
        const washerDryer = snapshot.washerDryer ?? {};
        const state = washerDryer.CurState;
        const error = washerDryer.ErrorCode;
        return {
            id: device.deviceId,
            name: device.alias,
            type: resolveDeviceType(device.deviceType, washerDryer.ProductType),
            status: toCardStatus(state, error, snapshot.online),
            courseName: washerDryer.CourseNum,
            remainTime: (Number(washerDryer.RemainHour) || 0) * 60 + (Number(washerDryer.RemainMin) || 0),
            cost: device.cost,
            cycle: device.count,
            error,
        };
    });

function DeviceDetailsSubTabContent({ shopCode }) {
    const storeService = new StoreService();
    const [devices, setDevices] = useState([]);

    useEffect(() => {
        if (!shopCode) return;
        storeService
            .getStoreDevice({ storeId: shopCode })
            .then((result) => {
                console.log("getStoreDevice result:", result);
                setDevices(parseDeviceList(result));
            })
            .catch((error) => {
                console.error("Error fetching device list:", error);
            });
    }, [shopCode]);

    return (
        <SingleScrollView $gridTemplateColumns={"repeat(auto-fill, 305px)"} $gap={12}>
            {devices.length <= 0 && <SizedBox height={"300px"} />}
            {devices.length > 0 &&
                devices.map((device, index) => <DeviceDetailCard key={device.id || index} device={device} />)}
        </SingleScrollView>
    );
}

export default DeviceDetailsSubTabContent;
